import { $sxhr } from "../../stempcore";
import { staticRequest } from "../service/index";
import URL from "../assets/conf/setting.json";
import $ from "jquery";
import { cr } from "fire-wind-water/core";
export default {
  //获取视频回放列表
  getVideoPlayBackList: info => {
    // return $.get("api/webinar/replay/getList", info);
    return $sxhr.post("api/webinar/replay/getList", info);
  },
  //获取会议信息
  getMeeting: info => {
    return staticRequest("api/webinar/get", info);
  }, //获取文件列表
  getResource: info => {
    return staticRequest("file/getList", info);
    //    return $sxhr.post("file/getList", info);
  }, //获取文件信息
  getFileInfo: info => {
    return $sxhr.post("file/folder/getReleaseFile", info);
  },
  recordFileDownLoad: info => {
    return $sxhr.post("open/interaction/fileDownLoad", info);
  },
  getConfig: info => {
    // return $sxhr.post("template/template/getConfig", info);
    return staticRequest("template/template/getConfig", info);
  }, //获取中奖结果
  getLotteryRecord: info => {
    return $sxhr.post("webinar/open/getLuckyDrawRoster", info);
  }, //获取参会人信息
    // 抽奖
   getLotteryLuck:info=>{
       return  window.$sk.$skxhr("luckyDraw/project/douyin/RAction", info,{
           headers:{
               'Content-Type':'application/json'
           }
       });

   },
  getContacts: info => {
    return $sxhr.post("api/webinar/contacts/get", info);
  }, //检查是否报名
  checkRegistration: info => {
    return $sxhr.post("webinar/open/checkRegistration", info);
  }, ////静默报名
  silentSignUp: info => {
    return $sxhr.post("api/webinar/contacts/signup", info);
  }, //获取服务器时间
  getServerTime: info => {
    return $sxhr.post("webinar/open/getServerTime", info);
  }, //检查session是否过期
  checkSess: info => {
    return $sxhr.post("anonymous/checkSess", info);
  },
  getOAuth: info => {
    return $sxhr.post("member/form/GetOAuthUrlByWeChatId", info);
  },
  getTokenByCode: info => {
    return $sxhr.post("api/member/verify/token/getbycode", info);
  },
  getMemberContacts: info => {
    return $sxhr.post("api/member/contacts/info/get", info);
  },
  join: info => {
    return $sxhr.post("webinar/open/join", info);
  },
  getRecommend: info => {
    return $sxhr.post("api/webinar/recommend/query", info);
  },
  liveSendmsg: info => {
    return $sxhr.post("api/webinar/live/sendmsg", info);
  },
  hasParticipation: info => {
    return $sxhr.post("api/questionnaire/hasparticipation", info);
  },
    isAllQuestionJoin: info => {
    return  window.$sk.$skxhr("questionary/project/douyin/checkAction", info,{
        headers:{
            'Content-Type':'application/json'
        }
    });
  },
  getQuestionnaire: info => {
    return staticRequest("api/questionnaire/get", info);
  },
    //提交问卷信息
    questionaryAction: (params) => {
        return window.$sk.$skxhr("questionary/action", params);
    },
  action: info=>{
    return $sxhr.post('customForm/action', info);
  },
    luckyDrawSaveUserInfo: info=>{
    return $sxhr.post('luckyDraw/client/saveUserInfo', info);
  },
    getNumberOfDraws: info=>{
        return $sxhr.post('luckyDraw/client/action', info);
    },
  voteHasParticipation: info => {
    return $sxhr.post("poll/HasParticipation", info);
  },
  getVote: info => {
    return staticRequest("poll/get", info);
  },
  //获取广播消息列表
  getNotices: info => {
    return $.get(
      URL.webinarbInteractUrl +
        "v1/api/webinars/" +
        info.webinarId +
        "/notifications",
      {
        page: info.page,
        limit: info.limit,
        status: info.status,
        sort: "updated_at",
        order: "desc",
        t: new Date().getTime()
      }
    );
  },
  //获取qa记录
  getQas: info => {
    return $.get(
      URL.webinarbInteractUrl + "v1/api/qa/" + info.webinarId + "/all",
      {
        page: info.page,
        limit: info.limit,
        updated_at: info.updated_at,
        user: info.user,
        sort: "updated_at",
        uncheckuser: info.uncheckuser,
        order: "desc",
        t: new Date().getTime()
      }
    );
  },
  //获取私聊记录
  getChats: info => {
    return $.get(
      URL.webinarbInteractUrl + "v1/api/qa/" + info.webinarId + "/chat/all",
      {
        page: info.page,
        limit: info.limit,
        from_user: info.from_user,
        to_user: info.to_user,
        updated_at: info.updated_at,
        sort: "updated_at",
        order: "desc",
        t: new Date().getTime()
      }
    );
  },
  //获取私聊列表
  getConversations: info => {
    return $.get(
      URL.webinarbInteractUrl + "v1/api/qa/" + info.webinarId + "/chat/users",
      {
        page: info.page,
        limit: info.limit,
        user: info.user,
        sort: "updated_at",
        order: "desc",
        t: new Date().getTime()
      }
    );
  },

  getLikeConfig: info => {
    return $.get(
      URL.webinarbInteractUrl + "v1/api/like/" + info.webinarId + "/config",
      {}
    );
  },
  getLiveLimit: info => {
    return $.get(
      URL.webinarbInteractUrl +
        "v1/api/webinars/" +
        info.tenantId +
        "/" +
        info.webinarId +
        "/online/num",
      {}
    );
  },

  downloadWithEmail: info => {
    return $sxhr.post("file/downloadWithEmail", info);
  },
  //上传文件
  upload: info => {
    const fd = new FormData();
    cr.each(info, (d, o) => {
      fd.append(o, d);
    });
    return $sxhr.upload(fd);
  },
  //禁言取消禁言
  gagTrue: info => {
    return $.get(
      URL.webinarbInteractUrl +
        "v1/api/webinars/" +
        info.webinarId +
        "/audiences/" +
        info.uid +
        "/gag/true",
      {
        globalUserId: info.globalUserId,
        t: new Date().getTime()
      }
    );
  },
  gagFalse: info => {
    return $.get(
      URL.webinarbInteractUrl +
        "v1/api/webinars/" +
        info.webinarId +
        "/audiences/" +
        info.uid +
        "/gag/false",
      {
        globalUserId: info.globalUserId,
        t: new Date().getTime()
      }
    );
  },
  //踢出
  kickout: info => {
    return $.get(
      URL.webinarbInteractUrl +
        "v1/api/webinars/" +
        info.webinarId +
        "/audiences/" +
        info.uid +
        "/delete",
      {
        globalUserId: info.globalUserId,
        tenantId: info.tenantId,
        t: new Date().getTime()
      }
    );
  }
};
